import { render, staticRenderFns } from "./LimitedUserCreation.vue?vue&type=template&id=152dde30&"
import script from "./LimitedUserCreation.vue?vue&type=script&lang=js&"
export * from "./LimitedUserCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('152dde30')) {
      api.createRecord('152dde30', component.options)
    } else {
      api.reload('152dde30', component.options)
    }
    module.hot.accept("./LimitedUserCreation.vue?vue&type=template&id=152dde30&", function () {
      api.rerender('152dde30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/LimitedUserCreation.vue"
export default component.exports